module.exports = __webpack_public_path__ + "img/mercadoPago.4effc7bf.jpg";